<template>
  <div class="top-app">
    <!--头部链接-->
    <div class="lianjie">
      <div class="w1200 flexDiv">
        <ul class="flexDiv">
          <li><a href="javascript:;">江苏省数控高职实训基地建设点</a></li>
          <li>
            <a href="javascript:;"
              >江苏省高等教育汽车类专业人才培养模式创新实验基地</a
            >
          </li>
        </ul>
        <ul class="flexDiv">
          <li><a href="javascript:;" target="_blank">董事长信箱</a></li>
          <li><a href="javascript:;" target="_blank">院长信箱</a></li>
          <li><a href="javascript:;" target="_blank">OA办公</a></li>
          <li><a href="javascript:;" target="_blank">金肯内网</a></li>
          <li>
            <a href="http://222.193.143.194/default.aspx" target="_blank"
              >教务系统</a
            >
          </li>
          <li>
            <a href="http://xxgk.jku.edu.cn/" target="_blank">信息公开</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="header">
      <div class="w1200">
        <div class="top flexDiv">
          <div class="logoDiv flexDiv">
            <p class="logoBox">
              <a href="./index.html"><img :src="topLogo.Logo" alt="logo"/></a>
            </p>
            <div class="code">
              <span>人事处</span><span>国标代码 13100</span>
            </div>
          </div>
          <div class="sousuoDiv">
            <p class="inputBox flexDiv">
              <input
                type="text"
                placeholder="请输入搜索内容"
                id="search"
                v-model="SearchStr"
                @keyup.enter="Search"
              />
              <a href="javascript:;" @click.stop="Search"
                ><img src="../assets/img/ss.png" alt=""
              /></a>
            </p>
          </div>
        </div>
      </div>
      <div class="daohang">
        <div class="w1200">
          <ul class="mulu flexDiv" id="navBox">
            <li v-for="item in menuListOne" :key="item.ID">
              <a
                v-if="item.Url.indexOf('http') == -1"
                :href="item.Url"
                class="topA"
                :class="[item.On ? 'on' : '']"
                >{{ item.Name }}</a
              >
              <router-link
                v-else
                :to="
                  item.Children.length == 0 ? item.Url : item.Children[0].Url
                "
                :key="CId"
                :class="[item.On ? 'on' : '']"
                ><i></i> {{ item.Name }}</router-link
              >
              <dl v-if="item.Children.length > 0" class="menuDl">
                <dd v-for="item2 in item.Children" :key="item2.ID">
                  <router-link
                    v-if="item2.Url.indexOf('http') == -1"
                    :to="item2.Url"
                    :key="item2.ID"
                    >{{ item2.Name }}</router-link
                  >
                  <a v-else :href="item2.Url">{{ item2.Name }}</a>
                </dd>
              </dl>
            </li>
            <li>
              <a href="http://www.njjku.com/" target="_blank">学院首页</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "top",
  data() {
    return {
      menuList: [],
      menuListOne: [],
      CId: this.$route.query.CId,
      SearchStr: null
    };
  },
  methods: {
    Search() {
      if (!this.SearchStr) {
        alert("请输入查找关键字");
      } else {
        this.$router.push("./search.html?selText=" + this.SearchStr);
      }
    }
  },
  created() {
    this.menuList = this.Base.GetNavColumnsByDid();
    this.menuListOne = this.menuList.filter(ele => ele.FID == 0);
    this.menuListOne.forEach(r => {
      r.Children = this.menuList.filter(ele => ele.FID == r.ID);
    });
    this.menuListOne.unshift({
      Name: "首页",
      Url: "./index.html",
      On: true,
      Children: []
    });
    // console.log(this.menuListOne,1)
    this.topLogo = this.Base.GetOrganInfoByOid(50);
    $(document).ready(function() {
      $("#navBox>li").hover(function() {
        $(this)
          .children("dl")
          .stop()
          .slideToggle("slow");
      });
    });
  }
};
</script>

<style lang="less" scoped>
.top-app {
  background-color: #f5f5f5;
  z-index: 999;
  .lianjie {
    display: none;
    height: 20px;
    background-color: #eaeeff;
    ul:first-child {
      width: 510px;
      li::after {
        content: "";
        width: 1px;
        height: 14px;
        background: #646464;
        position: absolute;
        right: -8px;
        bottom: 0;
        z-index: 11;
      }
    }
    ul:last-child {
      width: 452px;
      li::after {
        content: "";
        width: 1px;
        height: 14px;
        background: #0467ad;
        position: absolute;
        right: -13px;
        bottom: 0;
        z-index: 11;
      }
    }
    li {
      position: relative;
      a {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #646464;
        display: flex;
        align-items: center;
      }
    }
    li:last-child::after {
      display: none;
    }
  }

  /* header */
  .header {
    z-index: 2;
    position: relative;
    width: 100%;
    .top {
      height: 123px;
      align-items: center;
      .logoDiv {
        .logoBox {
          width: 396px;
          height: 102px;
          img {
            object-fit: contain;
          }
        }
        .code {
          margin-top: 24px;
          margin-left: 24px;
          position: relative;
          &::before {
            content: "";
            width: 1px;
            height: 49px;
            background-color: #0069b7;
            position: absolute;
            left: -15px;
            top: 0;
          }
          span {
            display: block;
            &:first-child {
              font-size: 20px;
              font-weight: bold;
              font-stretch: normal;
              line-height: 28px;
              letter-spacing: 1px;
              color: #0069b7;
            }
            &:last-child {
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 1px;
              color: #0069b7;
            }
          }
        }
      }
      .sousuoDiv {
        .inputBox {
          width: 410px;
          a {
            width: 40px;
            height: 40px;
            display: inline-block;
          }
          input {
            width: 310px;
            height: 37px;
            background-color: #ffffff;
            box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.38);
            border-radius: 5px;
            padding: 0 20px;
            color: #646464;
          }
        }
      }
    }
    /*导航栏*/
    .daohang {
      height: 54px;
      position: relative;
      height: 71px;
      .mulu {
        display: flex;
        justify-content: space-between;
        background: #fff;
        position: relative;
        &::after {
          content: "";
          width: 1160px;
          height: 26px;
          background-image: url(../assets/img/yy.png);
          background-size: 100% 100%;
          position: absolute;
          bottom: -26px;
          left: 20px;
          z-index: 888;
        }
        li {
          display: block;
          flex: 1;
          height: 71px;
          text-align: center;
          position: relative;
          &::after {
            content: "";
            width: 1px;
            height: 38px;
            background: #c8c8c8;
            position: absolute;
            right: 0;
            top: 16px;
          }
          &:hover {
            a.topA {
              color: #0376be;
            }
            &::before {
              content: "";
              width: 25px;
              height: 2px;
              background-color: #0376be;
              position: absolute;
              left: 53px;
              top: 52px;
            }
          }
          a {
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 70px;
            letter-spacing: 1px;
            color: #333333;
          }
          &:last-child::after {
            display: none;
          }
          .menuDl {
            display: none;
            dd {
              background: rgba(255, 255, 255, 0.9);
              margin-top: 1px;
              transition: all 0.4s;
              height: 60px;
              z-index: 999;
              &:hover {
                a {
                  color: #0376be;
                }
              }
              a {
                line-height: 60px;
              }
            }
          }
          a.on {
            color: #0376be;
            &::before {
              content: "";
              width: 25px;
              height: 2px;
              background-color: #0376be;
              position: absolute;
              left: 53px;
              top: 52px;
            }
          }
        }
        // li.on{
        // 	a.topA{
        // 		color: #0376be;
        // 		&::before{
        // 			content: '';
        // 			width: 25px;
        // 			height: 2px;
        // 			background-color: #0376be;
        // 			position: absolute;
        // 			left: 53px;
        // 			top: 52px;
        // 		}
        // 	}
        // }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue